import React, { memo } from "react";
import { useLanguage } from "../../utils/languageContext.js";
import { getTranslation } from "../../utils/translate.js";
import LoadingSpinner from "../../components/LoadingSpinner/loadingSpinner.js";

const PaymentTablePure = memo(({ rows = [], isLoading = false, containerId = 'payments-table-container' }) => {
  const { language } = useLanguage();

  return (
    <div className="rounded-md border border-gray-200 dark:border-[#30363d] bg-white dark:bg-[#161b22] mb-8">
      <div className="relative w-full overflow-auto">
        <table className="w-full caption-bottom text-sm">
          <thead className="[&_tr]:border-b border-gray-200 dark:border-[#30363d]">
            <tr className="border-b border-gray-200 dark:border-[#30363d] transition-colors hover:bg-white dark:hover:bg-[#1c2128]">
              <th className="h-12 px-4 text-left align-middle font-medium text-gray-600 dark:text-[#b1bac4]">{getTranslation('payments.orderNumber', language)}</th>
              <th className="h-12 px-4 text-left align-middle font-medium text-gray-600 dark:text-[#b1bac4]">{getTranslation('payments.amount', language)}</th>
              <th className="h-12 px-4 text-left align-middle font-medium text-gray-600 dark:text-[#b1bac4]">{getTranslation('payments.platformFee', language)}</th>
              <th className="h-12 px-4 text-left align-middle font-medium text-gray-600 dark:text-[#b1bac4]">{getTranslation('payments.chefEarning', language) || 'Chef Earning'}</th>
              <th className="h-12 px-4 text-left align-middle font-medium text-gray-600 dark:text-[#b1bac4]">{getTranslation('payments.paymentType', language)}</th>
              <th className="h-12 px-4 text-left align-middle font-medium text-gray-600 dark:text-[#b1bac4]">{getTranslation('promocodes.title', language)}</th>
            </tr>
          </thead>
          <tbody id={containerId} className="[&_tr:last-child]:border-0 max-h-[60vh] overflow-auto">
            {isLoading && rows.length === 0 ? (
              <tr>
                <td colSpan="6" className="h-24 text-center">
                  <LoadingSpinner />
                </td>
              </tr>
            ) : rows.length > 0 ? (
              rows.map((item) => (
                <tr key={`${item?.orderId}-${item?.orderNumber}`} className="border-b border-gray-200 dark:border-[#30363d] transition-colors hover:bg-white dark:hover:bg-[#1c2128]">
                  <td className="p-4 align-middle">
                    <a href={`/orders/${item?.orderId}`} className="font-mono text-blue-600 dark:text-[#58a6ff] hover:underline font-medium">
                      {item?.orderNumber}
                    </a>
                  </td>
                  <td className="p-4 align-middle font-medium text-gray-900 dark:text-[#c9d1d9]">{item?.totalPrice ?? 0} Դ</td>
                  <td className="p-4 align-middle text-gray-700 dark:text-[#b1bac4] font-medium">{item?.platformFee ?? 0}</td>
                  <td className="p-4 align-middle text-gray-700 dark:text-[#b1bac4] font-medium">{item?.chefEarning ?? 0}</td>
                  <td className="p-4 align-middle text-gray-700 dark:text-[#b1bac4] font-medium">{item?.paymentType}</td>
                  <td className="p-4 align-middle text-gray-700 dark:text-[#b1bac4] font-medium">{item?.promoCodeApplied ? getTranslation('common.yes', language) : getTranslation('common.no', language)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="h-24 text-center">
                  <div className="flex flex-col items-center space-y-2">
                    <div className="rounded-full bg-white dark:bg-[#0d1117] p-3 border dark:border-[#30363d]">
                      <svg className="h-6 w-6 text-gray-400 dark:text-[#8b949e]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <div className="space-y-1">
                      <h3 className="text-sm font-semibold text-gray-900 dark:text-[#c9d1d9]">{getTranslation('payments.noTransactionsShort', language)}</h3>
                      <p className="text-sm text-gray-600 dark:text-[#b1bac4] font-medium">{getTranslation('payments.noTransactions', language)}</p>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
});

PaymentTablePure.displayName = 'PaymentTablePure';

export default PaymentTablePure;

